import { Spin } from 'antd';
import { type ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

type Props = { children: ReactNode };

/** Blocks route when user is not admin. */
export const AdminRouteGate = ({ children }: Props) => {
	const isProfileLoading = useSelector(
		(state: any) => state?.userProfile?.isLoading,
	);
	const isAdmin = useSelector(
		(state: any) => state?.userProfile?.data?.isAdmin === true,
	);

	if (isProfileLoading) {
		return (
			<div style={{ display: 'flex', justifyContent: 'center', padding: 48 }}>
				<Spin size="large" />
			</div>
		);
	}

	if (!isAdmin) {
		return <Navigate to="/access-denied" replace />;
	}

	return <>{children}</>;
};
